/* Cart count update */
async function updateCartCount() {
  try {
    const data = await fetch('/cart/count.js').then(r => r.json());
    document.querySelectorAll('.cart-count, #CartCount').forEach(el => el.textContent = data.count);
  } catch(e) {}
}

/* Toast */
function showToast() {
  const t = document.getElementById('cartToast');
  if (!t) return;
  t.classList.add('show');
  setTimeout(() => t.classList.remove('show'), 3500);
}

document.addEventListener('DOMContentLoaded', function() {

  updateCartCount();

  /* Product form */
  const productForm = document.getElementById('ProductForm');
  if (productForm) {
    const sizeButtons = document.querySelectorAll('.pdp-size-btn');
    const variantInput = document.getElementById('variantId');
    const errorEl = document.getElementById('pdpError');
    const atcBtn = document.getElementById('pdpATC');
    let sizeChosen = sizeButtons.length === 0;

    sizeButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('sold-out')) return;
        sizeButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        if (variantInput) variantInput.value = btn.dataset.variantId;
        if (errorEl) errorEl.style.display = 'none';
        sizeChosen = true;
      });
    });

    const guideToggle = document.getElementById('sizeGuideToggle');
    const guidePanel = document.getElementById('sizeGuidePanel');
    if (guideToggle && guidePanel) {
      guideToggle.addEventListener('click', () => {
        const open = guidePanel.style.display !== 'none';
        guidePanel.style.display = open ? 'none' : 'block';
        guideToggle.textContent = open ? 'Size guide' : 'Hide guide';
      });
    }

    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (sizeButtons.length > 0 && !sizeChosen) {
        if (errorEl) errorEl.style.display = 'block';
        return;
      }
      if (!atcBtn) return;
      try {
        atcBtn.textContent = 'Adding...';
        atcBtn.disabled = true;
        atcBtn.classList.add('adding');
        const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(productForm) });
        if (!res.ok) throw new Error('Could not add to cart');
        showToast();
        await updateCartCount();
        atcBtn.textContent = 'Added \u2713';
        setTimeout(() => {
          atcBtn.textContent = 'Add to Cart';
          atcBtn.disabled = false;
          atcBtn.classList.remove('adding');
        }, 2000);
      } catch(err) {
        atcBtn.textContent = 'Add to Cart';
        atcBtn.disabled = false;
        atcBtn.classList.remove('adding');
      }
    });
  }

  /* Accordions */
  document.querySelectorAll('.pdp-accordion-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => trigger.closest('.pdp-accordion-item').classList.toggle('open'));
  });

  /* Cart qty buttons */
  document.querySelectorAll('.cart-qty-btn').forEach(btn => {
    btn.addEventListener('click', async () => {
      const line = parseInt(btn.dataset.line, 10);
      const delta = parseInt(btn.dataset.delta, 10);
      const qtySpan = btn.closest('.cart-item-qty').querySelector('.cart-qty-value');
      const newQty = Math.max(0, parseInt(qtySpan.textContent, 10) + delta);
      btn.disabled = true;
      await fetch('/cart/change.js', { method: 'POST', headers: {'Content-Type':'application/json'}, body: JSON.stringify({line, quantity: newQty}) });
      window.location.reload();
    });
  });

});